import React from "react"
import ApiService from "../../services/ApiService"

interface AvantLogoProps {
    size?: "sm" | "lg"
}

const widths = {
    sm: 90,
    lg: 156
}

export function AvantLogo({size = "sm"}: AvantLogoProps) {
    return <img
        style={{width: widths[size]}}
        src={`${ApiService.CDN_BASE_URL}resources/common/img/avant-logo-2025.svg`}
        alt={"Avant Logo"}
    />
}

export function AvantTitle({title}: { title: string }) {
    return <div
        style={{
            color: "#767676",
            fontFamily: "Cera, sans-serif",
            fontSize: 24,
            fontWeight: "bold",
            letterSpacing: 1,
            textAlign: "center",
            marginTop: 24
        }}
    >
        {title}
    </div>
}

export function AvantLogoHeader({title}: { title: string }) {
    return <header style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
        <AvantLogo size="lg"/>
        <AvantTitle title={title}/>
    </header>
}
